import React, {  useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import AutorizationIcon from "../icons/AutorizationIcon";
import config from '../other/config';
const {serverAPI} = config;
export default function CardManager(props) {
  const [avatar, setAvatar] = useState('');
  const classes = useStyles();
  let item = props.data;
  let field = item ? item.split(';') : '';

  for (let i = 0; i < field.length; i++) {
    if ( ['.jpg','.png', '.bmp', 'jpeg' ].includes(field[i].slice(-4).toLowerCase()) ) {

      if (avatar !== i) {
        setAvatar(i)
      }
    }
  }

  return (
    <Card className={classes.root} style={{ background: props.bgcolor ? props.bgcolor : '' }}>
      <CardContent className={classes.contentCntr}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
        >
          <Grid item container className={classes.avatarCntr}>
            <Avatar alt={field[0]} src={field ? `https://catalog.cft.ru/${field[avatar + 1]}/${field[avatar]}` : ''} className={classes.avatarLarge}>
              <AutorizationIcon />
            </Avatar>
          </Grid>

          <Grid item container className={classes.dataCntr}>
            <Typography component="p" className={classes.name}>
              {field ? field[0] : ''}
            </Typography>

            <Typography component="p" className={classes.position}>
              {field ? field[4] : ''}
            </Typography>

            <Typography component="p" className={classes.phone}>
              {field ? field[2] : ''}
            </Typography>

            <Typography component="p" className={classes.phone}>
              {field ? field[3] : ''}
            </Typography>

            <Typography component="a" href={`mailto:${field ? field[1] : ''}`} className={classes.eMail}>
              {field ? field[1] : ''}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}



const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 424,
    minWidth: 424,
    borderRadius: 16,
    boxShadow: 'none',
    backgroundColor: '#FFF',
    height: 300,

    [theme.breakpoints.down(696)]: {
      maxWidth: 264,
      minWidth: 264
    },
  },

  contentCntr: {
    padding: theme.spacing(5),
    // backgroundColor: '#F6F6FB',

    '&:last-child': {
      paddingBottom: theme.spacing(4.5)
    },

    [theme.breakpoints.down(696)]: {
      padding: 24
    },
  },

  avatarCntr: {
    width: 80,

    [theme.breakpoints.down(696)]: {
      display: 'none'
    },
  },

  dataCntr: {
    width: 241,
  },

  avatarLarge: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    backgroundColor: '#9BAFF3',
  },

  name: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    width: '100%'
  },

  position: {
    height: 96,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%'
  },

  phone: {
    marginTop: theme.spacing(0.5),
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    width: '100%'
  },

  eMail: {
    marginTop: theme.spacing(0.5),
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#2050FF',
    textDecoration: 'none',

    '&:hover':{
      color: '#8094FF',
      textDecoration: 'none',
      borderBottom: '1px dashed #8094FF',
    }
  },
}));